export const defaultFilters = () => ({
    pagination: {
        limit: 20,
        page: 1,
    },
    filter: {
      createdAt: {
        value: '',
        operator: 'bwn'
      },
      countries: {
        id: {
          value: '',
          operator: 'in'
        }
      },
      partners: {
        id: {
          value: '',
          operator: 'in'
        }
      },
      createdBy: {
        id: {
          value: '',
          operator: 'in'
        }
      },
      streams: {
        id: {
          value: '',
          operator: 'in'
        }
      },
    },
    sortBy: ['id'],
    sortDesc: [true],
    clientOptions: {
        filterPanelExpanded: false,
    },
})
